import type { ReactNode } from 'react';
import { Button, Dialog } from './ui';

interface ConfirmDialogProps {
  isOpen?: boolean;
  open?: boolean;
  title: string;
  message: ReactNode;
  confirmLabel?: string;
  cancelLabel?: string;
  variant?: 'danger' | 'default' | 'primary';
  onConfirm: () => void;
  onCancel: () => void;
}

export function ConfirmDialog({
  isOpen,
  open,
  title,
  message,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  variant = 'default',
  onConfirm,
  onCancel,
}: ConfirmDialogProps) {
  const dialogIsOpen = open ?? isOpen ?? false;
  const confirmVariant = variant === 'danger' ? 'danger' : 'primary';

  const description = typeof message === 'string' ? message : undefined;

  return (
    <Dialog
      open={dialogIsOpen}
      onClose={onCancel}
      title={title}
      description={description}
      size="sm"
      dismissOnOverlayClick={variant !== 'danger'}
      footer={(
        <>
          <Button variant="secondary" onClick={onCancel}>
            {cancelLabel}
          </Button>
          <Button variant={confirmVariant} onClick={onConfirm}>
            {confirmLabel}
          </Button>
        </>
      )}
    >
      {description ? null : message}
    </Dialog>
  );
}
